function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Video from './landing-page/Video.react';
var LandingPage = function LandingPage() {
  var _useSelector = useSelector(function (s) {
      return s.config;
    }),
    host = _useSelector.host;
  var _useState = useState('ap3'),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var vidArr = [{
    id: 'ap3',
    src: 'asphalt-plant-3.mp4',
    placeholder: 'asphalt-plant-3.jpg',
    overlay: {
      title: null,
      body: 'Welcome to Posillico Materials',
      link: 'Long Island`s Premier Construction Materials Supplier',
      url: ''
    }
  }, {
    id: 'wp2',
    src: 'wash-plant-2.mp4',
    placeholder: 'wash-plant-2.jpg',
    overlay: {
      title: 'Introducing the',
      body: 'Posillico Materials Wash Plant',
      link: 'Learn More About the Posillico Wash Plant >',
      url: '//www.posillicowashplant.com'
    }
  }, {
    id: 'ap2',
    src: 'asphalt-plant-2.mp4',
    placeholder: 'asphalt-plant-2.jpg',
    overlay: {
      title: null,
      body: 'Paving the Way to Tomorrow`s Infrastructure',
      link: 'Learn About our Asphalt Products',
      url: 'products/asphalt'
    }
  }, {
    id: 't1',
    src: 'tripper-1.mp4',
    placeholder: 'tripper-1.jpg',
    overlay: {
      title: null,
      body: 'Reduce your Consumption of Virgin Material',
      link: 'Learn About our Recycled Aggregate Products',
      url: 'products/recycled-aggregate'
    }
  }, {
    id: 'wp1',
    src: 'wash-plant-1.mp4',
    placeholder: 'wash-plant-1.jpg',
    overlay: {
      title: 'Ditch the Landfill!',
      body: 'Make the Environmentally Responsible Decision for Waste Disposal',
      link: 'Learn About our Waste Disposal Service',
      url: 'services/recycling/clean-fill-disposal',
      style: {
        width: 826,
        height: 207
      }
    }
  }];
  var barArr = [{
    title: 'Asphalt',
    subtitle: 'Explore Our Asphalt Products',
    src: 'asphalt.png',
    url: 'products/asphalt'
  }, {
    title: 'State Approved Stone',
    subtitle: 'Explore Our State Approved Stone Products',
    src: 'state-approved-stone.png',
    url: 'products/state-approved-stone'
  }, {
    title: 'Commercial',
    subtitle: 'Explore Our Commercial Products',
    src: 'commercial.png',
    url: 'products/commercial'
  }, {
    title: 'Reclaimed Asphalt',
    subtitle: 'Explore Our Reclaimed Asphalt Products',
    src: 'reclaime-asphalt.png',
    url: 'products/reclaimed-asphalt-pavement'
  }, {
    title: 'Washed Sand',
    subtitle: 'Explore Our Washed Sand Products',
    src: 'washed-sand.png',
    url: 'products/washed-sand'
  }, {
    title: 'Recycled Aggregate',
    subtitle: 'Explore Our Recycled Aggregate Products',
    src: 'recycled-aggregate.png',
    url: 'products/recycled-aggregate'
  }, {
    title: 'Recycled Clay',
    subtitle: 'Explore Our Recycled Clay Products',
    src: 'recycled-clay.png',
    url: 'products/recycled-clay'
  }];
  var onEnded = function onEnded(id) {
    vidArr.forEach(function (x, i) {
      if (x.id === id) {
        if (i < vidArr.length - 1) setActive(vidArr[i + 1].id);else setActive(vidArr[0].id);
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "landingpage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "landingpage-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(host, "/proof"),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof.png"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof-ro.png",
    className: "ro"
  }))), vidArr.map(function (x) {
    return /*#__PURE__*/React.createElement(Video, _extends({}, x, {
      active: active,
      onEnded: onEnded,
      key: x.id
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "vid-control"
  }, vidArr.map(function (x, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "vid-control__btn ".concat(active === x.id ? 'vid-control__btn--active' : ''),
      onClick: function onClick() {
        setActive(x.id);
      },
      key: "btn".concat(x.id)
    }, i + 1);
  })), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__bar"
  }, barArr.map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      className: "landingpage__bar--item",
      key: x.url
    }, /*#__PURE__*/React.createElement("div", {
      className: "landingpage__bar--content"
    }, /*#__PURE__*/React.createElement("img", {
      className: "landingpage__bar--bg-img",
      alt: "".concat(x.title, " - ").concat(x.subtitle),
      src: "/public/images/landingpage/".concat(x.src)
    }), /*#__PURE__*/React.createElement("div", {
      className: "landingpage__bar--txt"
    }, /*#__PURE__*/React.createElement(NavLink, {
      to: x.url
    }, /*#__PURE__*/React.createElement("img", {
      src: "/public/images/landingpage/arrow@3x.png",
      className: "landingpage__bar--arrow"
    }), /*#__PURE__*/React.createElement("div", {
      className: "landingpage__bar--title"
    }, x.title), /*#__PURE__*/React.createElement("div", {
      className: "landingpage__bar--subtitle"
    }, x.subtitle))), /*#__PURE__*/React.createElement("div", {
      className: "landingpage__bar--gradient"
    })));
  })));
};
export default LandingPage;